import React, { useEffect, useRef, useState } from 'react'
import { PuffLoader, PulseLoader } from 'react-spinners'
import TextEditor from '../components/ContentEditor';
import { setActiveTab } from '../redux/slices/Content/SetActiveTab';
import { useDispatch, useSelector } from 'react-redux';
import Management from './Management';
import { UpdateContentAPI } from '../redux/actions/Content/UpdateContentAction';
import { GetContentAPI } from '../redux/actions/Content/GetContentAction';
import { showErrorToast, showSuccessToast } from '../helpers/SweetAlert';
import { updateContentStateReset } from '../redux/slices/Content/UpdateContentSlice';
import { AddCategoryAPI, UpdateCategoryAPI } from '../redux/actions/Content/AddCategoryAction';
import { addCategoryStateReset } from '../redux/slices/Content/AddCategorySlice';
import { AddProductTypeAPI } from '../redux/actions/Content/AddProductTypeAction';
import { AddFoodCategoriesAPI } from '../redux/actions/Content/AddFoodCategoryAction';
import { UpdateFoodCategoryAPI } from '../redux/actions/Content/UpdateFoodCategoriesAction'
import { addProductTypeStateReset } from '../redux/slices/Content/AddProductTypeSlice';
import { useLoaderData, useLocation } from 'react-router-dom';
import { clearCategoriesResponse } from '../redux/slices/Content/GetCategoriesSlice';
import { clearFoodCategoriesResponse } from '../redux/slices/Content/GetFoodCategoriesSlice';
import { clearProductTypesResponse } from '../redux/slices/Content/GetProductTypesSlice';
import { AddUnitsAPI } from '../redux/actions/Content/AddUnitsAction';
import { addUnitsStateReset } from '../redux/slices/Content/AddUnitSlice';
import { clearUnitsListContentResponse } from '../redux/slices/Content/GetUnitsListContentSlice';
import { updateCategoryStateReset } from '../redux/slices/Content/UpdateCategorySlice';
import { updateFoodCategoriesStateReset } from "../redux/slices/Content/UpdateFoodCategoriesSlice"

const ContentManagement = () => {
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

    const dispatch = useDispatch();
    const location = useLocation();
    const editorRef = useRef();
    const { response: updateCategoryResponse, error: updateCategoryError } = useSelector((state) => state.updateCategory);
    const [categoriesFetchTrigger, setCategoriesFetchTrigger] = useState(false);
    const [foodCategoriesFetchTrigger, setFoodCategoriesFetchTrigger] = useState(false);
    // const [productTypeFetch, setProductTypeFetch] = useState(false);

    const [productTypeFetchTrigger, setProductTypeFetchTrigger] = useState(0);

    const [unitsFetchTrigger, setUnitsFetchTrigger] = useState(false);
    // const [activeTab, setActiveTab] = useState('categories');

    const [content, setContent] = useState('');
    const [images, setImages] = useState([]);
    const [category, setCategory] = useState('');
    const [units, setUnits] = useState(['']);
    const [singleUnit, setSingleUnit] = useState('');
    const [productType, setProductType] = useState('');
    const [validationErrors, setValidationErrors] = useState('');
    const [editCategoryId, setEditCategoryId] = useState('');
    const [editCategoryName, setEditCategoryName] = useState('');
    const [editCategoryUnits, setEditCategoryUnits] = useState(['']);
    const [editCategoryImages, setEditCategoryImages] = useState([]);
    const [editFoodCategory, setEditFoodCategory] = useState('');
    const [editFoodCategoryId, setEditFoodCategoryId] = useState('');
    const [editCategoryModalTrigger, setEditCategoryModalTrigger] = useState(0);
    const [foodCategory, setFoodCategory] = useState('');
    // const [newUnit, setNewUnit] = useState('');
    const { response: getContentResponse, error: getContentError } = useSelector((state) => state.getContent);
    const { response: updateReponse, error: updateError } = useSelector((state) => state.updateContent);
    const { response: addCategoryResponse, loading: addCategoryLoading, error: addCategoryError } = useSelector((state) => state.addCategory)
    const { response: addFoodCategoryResponse, loading: addFoodCategoryLoading, error: addFoodCategoryError } = useSelector((state) => state.addFoodCategories)
    const { response: updateFoodCategoryResponse, loading: updateFoodCategoryLoading, error: updateFoodCategoryError } = useSelector((state) => state.updateFoodCategories)
    const { response: addProductTypeResponse, loading: addProductTypeLoading, error: addProductTypeError } = useSelector((state) => state.addProducType)

    const { response: addSingleUnitResponse, loading: addSingleUnitLoading, error: addSingleUnitError } = useSelector((state) => state.addUnits)

    const tab = useSelector((state) => state.activeTab.tab);

    const validateForm = () => {
        const newErrors = {};
        if (!category.trim()) newErrors.category = true;
        const unitErrors = units.map(unit => !unit || unit.trim() === '');
        if (unitErrors.some(error => error)) {
            newErrors.units = unitErrors;
        }

        // if (images.length === 0) {
        //     newErrors.image = true;
        // }
        setValidationErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateProductTypeForm = () => {
        const newErrors = {};

        if (!productType.trim()) {
            newErrors.productType = true;
        }

        setValidationErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateFoodCategoryForm = () => {
        const newErrors = {};
        if (!foodCategory.trim()) {
            newErrors.foodCategory = true;
        }
        setValidationErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Add validation function
    const validateEditFoodCategoryForm = () => {
        const newErrors = {};
        if (!editFoodCategory.trim()) {
            newErrors.editFoodCategory = true;
        }
        setValidationErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Add edit handler
    const handleEditFoodCategoryClick = (category) => {
        setEditFoodCategoryId(category._id);
        setEditFoodCategory(category.foodCategoryName || category.name || '');
    };

    // Add edit submit handler
    const handleEditFoodCategorySubmit = async () => {
        if (!validateEditFoodCategoryForm()) return;

        try {
            await dispatch(UpdateFoodCategoryAPI({
                id: editFoodCategoryId,
                name: editFoodCategory
            }));
            setFoodCategoriesFetchTrigger(prev => prev + 1);
            const modalElement = document.getElementById('editFoodCategoryModal');
            const modal = window.bootstrap.Modal.getInstance(modalElement);
            if (modal) {
                modal.hide();
            } else {
                const newModal = new window.bootstrap.Modal(modalElement);
                newModal.hide();
            }
        } catch (error) {
            console.error('Error updating food category:', error);
        }
    };

    // Add reset function
    const resetEditFoodCategoryForm = () => {
        setEditFoodCategory('');
        setEditFoodCategoryId('');
        setValidationErrors('');
    };

    const validateSingleUnitForm = () => {
        const newErrors = {};

        if (!singleUnit.trim()) {
            newErrors.singleUnit = true;
        }

        setValidationErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleChange = (newContent) => {
        setContent(newContent);
    };

    const handleUpdateContent = async (type) => {
        if (!["1", "2"].includes(type)) {
            showErrorToast('Invalid content type provided!');
            return;
        }
        await dispatch(UpdateContentAPI({ type: type, description: content }));
    };

    // Add this function to handle edit submission
    const handleEditSubmit = async () => {
        if (!validateEditForm()) return;

        const formData = new FormData();
        if (editCategoryImages.length > 0 && editCategoryImages[0].file) {
            formData.append('image', editCategoryImages[0].file);
        }

        formData.append('name', editCategoryName);
        formData.append('units', editCategoryUnits);
        formData.append('id', editCategoryId);

        try {
            await dispatch(UpdateCategoryAPI(formData));
            setEditCategoryModalTrigger(prev => prev + 1);
        } catch (error) {
            console.error('Error updating category:', error);
        }
    };

    // Add this validation function
    const validateEditForm = () => {
        const newErrors = {};
        if (!editCategoryName.trim()) newErrors.editCategoryName = true;
        const unitErrors = editCategoryUnits.map(unit => !unit || unit.trim() === '');
        if (unitErrors.some(error => error)) {
            newErrors.editCategoryUnits = unitErrors;
        }
        setValidationErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Add this function to handle edit click
    const handleEditClick = (category) => {
        setEditCategoryId(category._id);
        setEditCategoryName(category.name);
        setEditCategoryUnits(category.units ? category.units.map(unit => unit.toString()) : ['']);
        if (category.image) {
            setEditCategoryImages([{
                url: category.image,
                // If you need to handle file objects differently for existing images
                file: null // or create a file object if needed
            }]);
        } else {
            setEditCategoryImages([]);
        }
    };

    // Add this function to reset edit form
    const resetEditFormFields = () => {
        setEditCategoryId('');
        setEditCategoryName('');
        setEditCategoryUnits(['']);
        setEditCategoryImages([]);
        setValidationErrors('');
    };

    // Add these near other useEffect hooks
    useEffect(() => {
        if (updateCategoryResponse?.status === true) {
            showSuccessToast(updateCategoryResponse?.message);
            resetEditFormFields();
            dispatch(updateCategoryStateReset());
            setCategoriesFetchTrigger(prev => prev + 1);
            const modalElement = document.getElementById('editCategoryModal');
            const modal = window.bootstrap.Modal.getInstance(modalElement);
            if (modal) {
                modal.hide();
            } else {
                const newModal = new window.bootstrap.Modal(modalElement);
                newModal.hide();
            }
        }
        if (updateCategoryError) {
            showErrorToast(updateCategoryError?.data);
            dispatch(updateCategoryStateReset());
        }
    }, [updateCategoryResponse, updateCategoryError, dispatch]);


    const handleFileChange = (e) => {

        const files = Array.from(e.target.files);

        if (files.length > 1 || images.length >= 1) {
            showErrorToast("Only one image is allowed to be uploaded.");
            // alert("Only one image is allowed to be uploaded.");
            return;
        }

        const file = files[0];

        if (!allowedTypes.includes(file.type)) {
            showErrorToast(`Invalid file type: ${file.name}`);
            // alert(`Invalid file type: ${file.name}`);
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            showErrorToast(`File ${file.name} exceeds 2MB size limit.`);
            // alert(`File ${file.name} exceeds 2MB size limit.`);
            return;
        }

        const preview = {
            file,
            url: URL.createObjectURL(file),
        };

        setImages([preview]);
    };

    const handleRemoveImage = () => {
        setImages([]);
    };

    // Edit category image handlers
    const handleEditDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);

        if (files.length > 1 || editCategoryImages.length >= 1) {
            showErrorToast("Only one image is allowed to be uploaded.");
            return;
        }

        const file = files[0];

        if (!allowedTypes.includes(file.type)) {
            showErrorToast(`Invalid file type: ${file.name}`);
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            showErrorToast(`File ${file.name} exceeds 2MB size limit.`);
            return;
        }

        const preview = {
            file,
            url: URL.createObjectURL(file),
        };

        setEditCategoryImages([preview]);
    };

    const handleEditDragOver = (e) => {
        e.preventDefault();
    };

    const handleEditFileChange = (e) => {
        const files = Array.from(e.target.files);

        if (files.length > 1 || editCategoryImages.length >= 1) {
            showErrorToast("Only one image is allowed to be uploaded.");
            return;
        }

        const file = files[0];

        if (!allowedTypes.includes(file.type)) {
            showErrorToast(`Invalid file type: ${file.name}`);
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            showErrorToast(`File ${file.name} exceeds 2MB size limit.`);
            return;
        }

        const preview = {
            file,
            url: URL.createObjectURL(file),
        };

        setEditCategoryImages([preview]);
    };

    const handleRemoveEditImage = (index) => {
        const updatedImages = [...editCategoryImages];
        updatedImages.splice(index, 1);
        setEditCategoryImages(updatedImages);
    };




    const handleDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);

        if (files.length > 1 || images.length >= 1) {
            showErrorToast("Only one image is allowed to be uploaded.");
            return;
        }

        const file = files[0];

        if (!allowedTypes.includes(file.type)) {
            showErrorToast(`Invalid file type: ${file.name}`);
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            showErrorToast(`File ${file.name} exceeds 2MB size limit.`);
            return;
        }

        const preview = {
            file,
            url: URL.createObjectURL(file),
        };

        setImages([preview]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;

        const formData = new FormData();
        if (images.length > 0) {
            formData.append('image', images[0].file);
        }

        formData.append('name', category);
        formData.append('units', units);

        try {
            await dispatch(AddCategoryAPI(formData));
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    }
    const handleSubmit2 = async () => {
        if (!validateProductTypeForm()) return;

        try {
            await dispatch(AddProductTypeAPI({ name: productType }));
        } catch (error) {
            console.error('Error submitting productType:', error);
        }
    }

    const handleSubmit3 = async () => {
        if (!validateSingleUnitForm()) return;

        try {
            await dispatch(AddUnitsAPI({ unitName: singleUnit }));
        } catch (error) {
            console.error('Error submitting unit:', error);
        }
    }

    const handleSubmit4 = async () => {
        if (!validateFoodCategoryForm()) return;

        try {
            await dispatch(AddFoodCategoriesAPI({ name: foodCategory }));
        } catch (error) {
            console.error('Error submitting food category:', error);
        }
    };

    const resetFormFields = () => {
        setImages([]);
        setCategory('');
        setUnits(['']);
        setValidationErrors('');
        setProductType('');
        setSingleUnit('');
        setFoodCategory('');
    };

    useEffect(() => {
        dispatch(setActiveTab('categories'));
    }, [])
    // useEffect(() => {
    //     dispatch(setActiveTab('foodCategories'));
    // }, [])

    // Add this with other useEffect hooks
    useEffect(() => {
        if (addFoodCategoryResponse) {
            showSuccessToast(addFoodCategoryResponse?.message);
            resetFormFields();
            dispatch(clearFoodCategoriesResponse());
            setFoodCategoriesFetchTrigger(prev => prev + 1);
            const modalElement = document.getElementById('addFoodCategoryModal');
            const modal = window.bootstrap.Modal.getInstance(modalElement);
            if (modal) {
                modal.hide();
            } else {
                const newModal = new window.bootstrap.Modal(modalElement);
                newModal.hide();
            }
        }
        if (addFoodCategoryError) {
            showErrorToast(addFoodCategoryError?.data);
            // Add your reset action here if available
        }
    }, [addFoodCategoryResponse, addFoodCategoryError]);

    useEffect(() => {
        if (updateFoodCategoryResponse?.status === true) {
            showSuccessToast(updateFoodCategoryResponse.message);
            resetEditFoodCategoryForm();
            setFoodCategoriesFetchTrigger(prev => prev + 1);
            const modalElement = document.getElementById('editFoodCategoryModal');
            const modal = window.bootstrap.Modal.getInstance(modalElement);
            if (modal) {
                modal.hide();
            } else {
                const newModal = new window.bootstrap.Modal(modalElement);
                newModal.hide();
            }
            dispatch(updateFoodCategoriesStateReset());
        }
        if (updateFoodCategoryError) {
            showErrorToast(updateFoodCategoryError.message || 'Failed to update food category');
            dispatch(updateFoodCategoriesStateReset());
        }
    }, [updateFoodCategoryResponse, updateFoodCategoryError, dispatch]);


    useEffect(() => {
        let type;
        if (tab == 'terms') {
            type = '1'
        }
        if (tab == 'about') {
            type = '2'
        }
        (tab == 'terms' || tab == 'about') && (dispatch(GetContentAPI({ type: type })));

    }, [tab, dispatch]);

    useEffect(() => {
        if (getContentResponse?.data?.description) {
            setContent(getContentResponse?.data?.description);
        }
    }, [getContentResponse]);

    useEffect(() => {
        if (getContentError) {
            setContent('');
            showErrorToast(getContentError.data)
        }
    }, [getContentError])

    useEffect(() => {
        if (updateReponse?.status === true) {
            showSuccessToast(updateReponse?.message);
            dispatch(updateContentStateReset());
        }
        if (updateError) {
            showErrorToast(updateError?.data);
            dispatch(updateContentStateReset());
        }
    }, [updateReponse, dispatch, updateError]);

    // useEffect(() => {
    //     dispatch(setActiveTab(''));
    // }, [location, tab]);

    useEffect(() => {
        const categoryModal = document.getElementById('addCategoryModal');
        const productTypeModal = document.getElementById('addProductTypeModal');

        const handleCategoryModalClose = () => resetFormFields();
        const handleProductTypeModalClose = () => resetFormFields();

        if (categoryModal) {
            categoryModal.addEventListener('hidden.bs.modal', handleCategoryModalClose);
        }
        if (productTypeModal) {
            productTypeModal.addEventListener('hidden.bs.modal', handleProductTypeModalClose);
        }

        // Cleanup on unmount
        return () => {
            if (categoryModal) {
                categoryModal.removeEventListener('hidden.bs.modal', handleCategoryModalClose);
            }
            if (productTypeModal) {
                productTypeModal.removeEventListener('hidden.bs.modal', handleProductTypeModalClose);
            }
        };
    }, []);

    useEffect(() => {
        if (addCategoryResponse?.status === true) {
            showSuccessToast(addCategoryResponse?.message);
            resetFormFields();
            dispatch(addCategoryStateReset());
            setCategoriesFetchTrigger(prev => prev + 1);
            const modalElement = document.getElementById('addCategoryModal');
            const modal = window.bootstrap.Modal.getInstance(modalElement);
            if (modal) {
                resetFormFields();
                modal.hide();

            } else {
                const newModal = new window.bootstrap.Modal(modalElement);
                resetFormFields();
                newModal.hide();

            };
        }
        if (addCategoryError) {
            showErrorToast(addCategoryError?.data);
            dispatch(addCategoryStateReset());
        }
    }, [addCategoryResponse, addCategoryError])


    useEffect(() => {
        if (addProductTypeResponse?.status === true) {
            showSuccessToast(addProductTypeResponse?.message);
            resetFormFields();
            dispatch(addProductTypeStateReset());
            setProductTypeFetchTrigger(prev => prev + 1);
            const modalElement = document.getElementById('addProductTypeModal');
            const modal = window.bootstrap.Modal.getInstance(modalElement);
            if (modal) {
                resetFormFields();
                modal.hide();

            } else {
                const newModal = new window.bootstrap.Modal(modalElement);
                resetFormFields();
                newModal.hide();

            };
        }
        if (addProductTypeError) {
            showSuccessToast(addProductTypeError?.data);
            dispatch(addProductTypeStateReset());
        }
    }, [addProductTypeResponse, addProductTypeError])


    useEffect(() => {
        if (addSingleUnitResponse?.status === true) {
            showSuccessToast(addSingleUnitResponse?.message);
            resetFormFields();
            dispatch(addUnitsStateReset());
            setUnitsFetchTrigger(prev => prev + 1);
            const modalElement = document.getElementById('addUnitsModal');
            const modal = window.bootstrap.Modal.getInstance(modalElement);
            if (modal) {
                modal.hide();

            } else {
                const newModal = new window.bootstrap.Modal(modalElement);
                newModal.hide();

            };
        }
        if (addSingleUnitError) {
            showSuccessToast(addSingleUnitError?.data);
            dispatch(addUnitsStateReset());
        }
    }, [addSingleUnitResponse, addSingleUnitError])

    // useEffect(() => {
    //     console.log(tab, "tab")
    //     if (tab === 'categories') {
    //         setCategoriesFetch(true)
    //     }
    //     if (tab === 'productTypes') {
    //         setProductTypeFetch(true)
    //     }
    // }, [tab])

    // useEffect(() => {
    //     if (categoriesFetch) {
    //         setCategoriesFetch(false); // reset to prevent repeated fetches
    //     }
    // }, [categoriesFetch]);

    // useEffect(() => {
    //     if (productTypeFetch) {
    //         setProductTypeFetch(false); // reset to prevent repeated fetches
    //     }
    // }, [categoriesFetch]);


    return (
        <>
            <section className='main'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='common_tabs'>
                                <nav>
                                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                        <button className={`nav-link ${tab === 'categories' ? 'active' : ''}`} id="nav-cmt-1-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-1" type="button" role="tab" aria-controls="nav-cmt-1" aria-selected="true" onClick={() => {
                                            dispatch(setActiveTab('categories'));
                                            dispatch(clearCategoriesResponse())
                                        }}>Categories</button>
                                        <button className={`nav-link ${tab === 'foodCategories' ? 'active' : ''}`} id="nav-cmt-2-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-2" type="button" role="tab" aria-controls="nav-cmt-2" aria-selected="false" onClick={() => {
                                            dispatch(setActiveTab('foodCategories'));
                                            dispatch(clearFoodCategoriesResponse())
                                        }}>Food Categories</button>
                                        <button className={`nav-link ${tab === 'productTypes' ? 'active' : ''}`} id="nav-cmt-3-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-3" type="button" role="tab" aria-controls="nav-cmt-3" aria-selected="false" onClick={() => {
                                            dispatch(setActiveTab('productTypes'));
                                            dispatch(clearProductTypesResponse())
                                        }}>Product Type</button>
                                        <button className={`nav-link ${tab === 'unit' ? 'active' : ''}`} id="nav-cmt-4-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-4" type="button" role="tab" aria-controls="nav-cmt-4" aria-selected="false" onClick={() => {
                                            dispatch(setActiveTab('units'));
                                            dispatch(clearUnitsListContentResponse())
                                        }}>Units</button>
                                        <button className={`nav-link ${tab === 'terms' ? 'active' : ''}`} id="nav-cmt-5-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-5" type="button" role="tab" aria-controls="nav-cmt-5" aria-selected="false" onClick={() => dispatch(setActiveTab('terms'))}>Terms & Conditions</button>
                                        <button className={`nav-link ${tab === 'about' ? 'active' : ''}`} id="nav-cmt-6-tab" data-bs-toggle="tab" data-bs-target="#nav-cmt-6" type="button" role="tab" aria-controls="nav-cmt-6" aria-selected="false" onClick={() => dispatch(setActiveTab('about'))}>About Us</button>
                                    </div>
                                </nav>
                                <div className="tab-content" id="nav-tabContent">
                                    {tab === 'categories' && <div className={`tab-pane fade ${tab === 'categories' ? 'show active' : ''}`} id="nav-cmt-1" role="tabpanel" aria-labelledby="nav-cmt-1-tab" tabIndex={0}>
                                        <Management tab={tab} categoriesFetch={categoriesFetchTrigger} />
                                    </div>}
                                    {tab === 'foodCategories' && (
                                        <div className={`tab-pane fade ${tab === 'foodCategories' ? 'show active' : ''}`} id="nav-cmt-2" role="tabpanel" aria-labelledby="nav-cmt-2-tab" tabIndex={0}>
                                            <Management tab={tab} foodCategoriesFetch={foodCategoriesFetchTrigger} handleEditClick={handleEditFoodCategoryClick} />
                                        </div>
                                    )}

                                    {tab === 'productTypes' && <div className={`tab-pane fade ${tab === 'productTypes' ? 'show active' : ''}`} id="nav-cmt-3" role="tabpanel" aria-labelledby="nav-cmt-3-tab" tabIndex={0}>
                                        <Management tab={tab} productTypeFetch={productTypeFetchTrigger} />
                                    </div>}

                                    {tab === 'units' && <div className={`tab-pane fade ${tab === 'units' ? 'show active' : ''}`} id="nav-cmt-4" role="tabpanel" aria-labelledby="nav-cmt-4-tab" tabIndex={0}>

                                        <Management tab={tab} unitsFetch={unitsFetchTrigger} />


                                    </div>}

                                    {tab === 'terms' && <div className={`tab-pane fade ${tab === 'terms' ? 'show active' : ''}`} id="nav-cmt-5" role="tabpanel" aria-labelledby="nav-cmt-5-tab" tabIndex={0}>

                                        {!content ? (
                                            <PulseLoader color='#000000' />
                                        ) : (
                                            <TextEditor content={content} onChange={handleChange} />
                                        )}

                                        <div className="d-flex justify-content-center align-items-center mt-4"><button className="primary-btn py-2" onClick={() => handleUpdateContent('1')}>Save</button></div>

                                        {/* <div>
                                        <h2>Content Preview</h2>
                                        <div dangerouslySetInnerHTML={{ __html: content }}></div>
                                    </div> */}
                                    </div>}
                                    {tab === 'about' && <div className={`tab-pane fade ${tab === 'about' ? 'show active' : ''}`} id="nav-cmt-5" role="tabpanel" aria-labelledby="nav-cmt-5-tab" tabIndex={0}>
                                        {!content ? (
                                            <PulseLoader color='#000000' />
                                        ) : (
                                            <TextEditor content={content} onChange={handleChange} />
                                        )}
                                        <div className="d-flex justify-content-center align-items-center mt-4"><button className="primary-btn py-2" onClick={() => handleUpdateContent('2')}>Save</button></div>

                                    </div>}

                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </section >

            <div className="modal fade" id="editCategoryModal" tabIndex={-1} aria-labelledby="editCategoryModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-2 fw-bold text-black" id="editCategoryLabel">Edit Category</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body detail-modal-body">
                            <div className='modal-field mb-2'>
                                <div className="input_wrapper">
                                    <label>Upload Category Image</label>
                                    <div className="form_field form_field_upload" onDrop={handleEditDrop}
                                        onDragOver={handleEditDragOver}>
                                        <input type="file" className='d-none' id='editUploadImg' onChange={handleEditFileChange} accept="image/jpeg, image/png, image/jpg, image/webp, image/svg+xml" />
                                        <label htmlFor='editUploadImg'>
                                            <span><img src='/assets/icons/upload-icon.svg' /></span>
                                            <span>Drag or drop here</span>
                                            <span>or</span>
                                            <span className='primary_text'>Browse</span>
                                        </label>
                                    </div>
                                    <span className="required_info">Maximum 2MB image size and only accepted jpeg, png, jpg, gif, svg, webp Maximum upload limit is 1.</span>
                                    <div className={`image-preview-list mt-3 ${editCategoryImages.length > 0 ? 'd-flex' : 'd-none'} flex-wrap gap-2`}>
                                        {editCategoryImages.map((img, index) => (
                                            <div key={index} className='preview-img-box position-relative'>
                                                <img
                                                    src={img.url}
                                                    alt={`preview-${index}`}
                                                    style={{
                                                        width: '80px',
                                                        height: '80px',
                                                        objectFit: 'cover',
                                                        borderRadius: '8px',
                                                        border: '1px solid #ddd',
                                                    }}
                                                />
                                                <button
                                                    type='button'
                                                    onClick={() => handleRemoveEditImage(index)}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '-6px',
                                                        right: '-6px',
                                                        backgroundColor: '#fff',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '50%',
                                                        width: '20px',
                                                        height: '20px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '12px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    &times;
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="input_wrapper">
                                    <label>Category Name</label>
                                    <div className="form_field">
                                        <input type="text" className={`form-control ${validationErrors.editCategoryName ? 'is-invalid' : ''}`}
                                            placeholder="Enter name"
                                            value={editCategoryName}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.length === 1 && value === ' ') return;
                                                setEditCategoryName(value);
                                                if (validationErrors.editCategoryName) {
                                                    setValidationErrors(prev => ({ ...prev, editCategoryName: false }));
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="input_wrapper">
                                    <label>Add Units</label>
                                    {editCategoryUnits.map((unit, index) => (
                                        <div key={index} className='d-flex justify-content-start gap-3'>
                                            <div className="form_field" style={{ width: 'calc(100% - 66px)' }}>
                                                <input type="number" className={`form-control ${validationErrors.editCategoryUnits?.[index] ? 'is-invalid' : ''}`}
                                                    placeholder="Enter units"
                                                    value={unit}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d*$/.test(value)) {
                                                            const updatedUnits = [...editCategoryUnits];
                                                            updatedUnits[index] = value;
                                                            setEditCategoryUnits(updatedUnits);
                                                            if (validationErrors.editCategoryUnits?.[index]) {
                                                                const updatedUnitErrors = [...validationErrors.editCategoryUnits];
                                                                updatedUnitErrors[index] = false;
                                                                setValidationErrors((prev) => ({
                                                                    ...prev,
                                                                    editCategoryUnits: updatedUnitErrors,
                                                                }));
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <button className='delete_item_btn bg-white p-0' onClick={() => {
                                                const updatedUnits = editCategoryUnits.filter((_, i) => i !== index);
                                                setEditCategoryUnits(updatedUnits);
                                            }}>
                                                <img src="/assets/icons/delete-red-icon.svg" />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <button className='add_item_btn border-0 fw-semibold fs-14 primary_text bg-white p-0' onClick={() => {
                                if (editCategoryUnits[editCategoryUnits.length - 1].trim() !== '') {
                                    setEditCategoryUnits([...editCategoryUnits, '']);
                                }
                            }}>
                                + Add more
                            </button>
                            <div className='modal_btn d-flex justify-content-end gap-2 p-0 mt-4'>
                                <button className='transparent-btn fs-14 py-2' data-bs-dismiss="modal">Cancel</button>
                                <button className='primary-btn fs-14 py-2' onClick={handleEditSubmit}>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* Update Category Modal */}
            <div className="modal fade" id="updateCategoryModal" tabIndex={-1} aria-labelledby="updateCategoryModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-2 fw-bold text-black" id="updateCategoryLabel">Update Category</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body detail-modal-body">
                            <div className='modal-field mb-2'>
                                <div className="input_wrapper">
                                    <label>Upload Category Image</label>
                                    <div className="form_field form_field_upload" onDrop={handleDrop}
                                        onDragOver={handleDragOver}>
                                        <input type="file" className='d-none' id='updateUploadImg' onChange={handleFileChange} accept="image/jpeg, image/png, image/jpg, image/webp, image/svg+xml" />
                                        <label htmlFor='updateUploadImg'>
                                            <span><img src='/assets/icons/upload-icon.svg' /></span>
                                            <span>Drag or drop here</span>
                                            <span>or</span>
                                            <span className='primary_text'>Browse</span>
                                        </label>
                                    </div>
                                    <span className="required_info">Maximum 2MB image size and only accepted jpeg, png, jpg, gif, svg, webp Maximum upload limit is 1.</span>
                                    <div className={`image-preview-list mt-3 ${images.length > 0 ? 'd-flex' : 'd-none'} flex-wrap gap-2`}>
                                        {images.map((img, index) => (
                                            <div key={index} className='preview-img-box position-relative'>
                                                <img
                                                    src={img.url}
                                                    alt={`preview-${index}`}
                                                    style={{
                                                        width: '80px',
                                                        height: '80px',
                                                        objectFit: 'cover',
                                                        borderRadius: '8px',
                                                        border: '1px solid #ddd',
                                                    }}
                                                />
                                                <button
                                                    type='button'
                                                    onClick={() => handleRemoveImage(index)}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '-6px',
                                                        right: '-6px',
                                                        backgroundColor: '#fff',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '50%',
                                                        width: '20px',
                                                        height: '20px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '12px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    &times;
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="input_wrapper">
                                    <label>Category Name</label>
                                    <div className="form_field">
                                        <input type="text" className={`form-control ${validationErrors.category ? 'is-invalid' : ''}`}
                                            placeholder="Enter name"
                                            value={category}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.length === 1 && value === ' ') return;
                                                setCategory(value);
                                                if (validationErrors.title) {
                                                    setValidationErrors(prev => ({ ...prev, category: false }));
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="input_wrapper">
                                    <label>Update Units</label>
                                    {units.map((unit, index) => (
                                        <div key={index} className='d-flex justify-content-start gap-3'>
                                            <div className="form_field" style={{ width: 'calc(100% - 66px)' }}>
                                                <input
                                                    type="number"
                                                    className={`form-control ${validationErrors.units?.[index] ? 'is-invalid' : ''}`}
                                                    placeholder="Enter units"
                                                    value={unit}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d*$/.test(value)) {
                                                            const updatedUnits = [...units];
                                                            updatedUnits[index] = value;
                                                            setUnits(updatedUnits);

                                                            if (validationErrors.units?.[index]) {
                                                                const updatedUnitErrors = [...validationErrors.units];
                                                                updatedUnitErrors[index] = false;
                                                                setValidationErrors((prev) => ({
                                                                    ...prev,
                                                                    units: updatedUnitErrors,
                                                                }));
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>

                                            <button
                                                className='delete_item_btn bg-white p-0'
                                                onClick={() => {
                                                    const updatedUnits = units.filter((_, i) => i !== index);
                                                    setUnits(updatedUnits);
                                                }}
                                            >
                                                <img src="/assets/icons/delete-red-icon.svg" />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <button
                                className='add_item_btn border-0 fw-semibold fs-14 primary_text bg-white p-0'
                                onClick={() => {
                                    if (units[units.length - 1].trim() !== '') {
                                        setUnits([...units, '']);
                                    }
                                }}
                            >
                                + Add more
                            </button>
                            <div className='modal_btn d-flex justify-content-end gap-2 p-0 mt-4'>
                                <button className='transparent-btn fs-14 py-2' onClick={resetFormFields}>Cancel</button>
                                {/* <button className='primary-btn fs-14 py-2' onClick={handleUpdateCategory}>Update</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <add category modal> */}
            < div className="modal fade" id="addCategoryModal" tabIndex={- 1
            } aria-labelledby="addCategoryModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-2 fw-bold text-black" id="addCategoryLabel">Add new category</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body detail-modal-body">
                            <div className='modal-field mb-2'>
                                <div className="input_wrapper">
                                    <label>Upload Category Image</label>
                                    <div className="form_field form_field_upload" onDrop={handleDrop}
                                        onDragOver={handleDragOver}>
                                        <input type="file" className='d-none' id='uploadImg' onChange={handleFileChange} accept="image/jpeg, image/png, image/jpg, image/webp, image/svg+xml" />
                                        <label htmlFor='uploadImg'>
                                            <span><img src='/assets/icons/upload-icon.svg' /></span>
                                            <span>Drag or drop here</span>
                                            <span>or</span>
                                            <span className='primary_text'>Browse</span>
                                        </label>
                                    </div>
                                    <span className="required_info">Maximum 2MB image size and only accepted jpeg, png, jpg, gif, svg, webp Maximum upload limit is 1.</span>
                                    <div className={`image-preview-list mt-3 ${images.length > 0 ? 'd-flex' : 'd-none'} flex-wrap gap-2`}> {/* toggle d-none with d-flex */}
                                        {images.map((img, index) => (
                                            <div key={index} className='preview-img-box position-relative'>
                                                <img
                                                    src={img.url}
                                                    alt={`preview-${index}`}
                                                    style={{
                                                        width: '80px',
                                                        height: '80px',
                                                        objectFit: 'cover',
                                                        borderRadius: '8px',
                                                        border: '1px solid #ddd',
                                                    }}
                                                />
                                                <button
                                                    type='button'
                                                    onClick={() => handleRemoveImage(index)}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '-6px',
                                                        right: '-6px',
                                                        backgroundColor: '#fff',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '50%',
                                                        width: '20px',
                                                        height: '20px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '12px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    &times;
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="input_wrapper">
                                    <label>Category Name</label>
                                    <div className="form_field">
                                        <input type="text" className={`form-control ${validationErrors.category ? 'is-invalid' : ''}`} placeholder="Enter name" value={category} onChange={(e) => {
                                            const value = e.target.value;
                                            if (value.length === 1 && value === ' ') return;
                                            setCategory(value);
                                            if (validationErrors.title) {
                                                setValidationErrors(prev => ({ ...prev, category: false }));
                                            }
                                        }} />
                                    </div>
                                </div>
                                <div className="input_wrapper">
                                    <label>Add Units</label>
                                    {units.map((unit, index) => (
                                        <div key={index} className='d-flex justify-content-start gap-3'>
                                            <div className="form_field" style={{ width: 'calc(100% - 66px)' }}>
                                                <input type="number" className={`form-control ${validationErrors.units?.[index] ? 'is-invalid' : ''}`} placeholder="Enter units" value={unit}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        // Allow only digits (no spaces, no decimals, no negative numbers)
                                                        if (/^\d*$/.test(value)) {
                                                            const updatedUnits = [...units];
                                                            updatedUnits[index] = value;
                                                            setUnits(updatedUnits);

                                                            // Clear validation error for this specific unit
                                                            if (validationErrors.units?.[index]) {
                                                                const updatedUnitErrors = [...validationErrors.units];
                                                                updatedUnitErrors[index] = false;
                                                                setValidationErrors((prev) => ({
                                                                    ...prev,
                                                                    units: updatedUnitErrors,
                                                                }));
                                                            }
                                                        }
                                                    }
                                                    }
                                                />
                                            </div>

                                            <button className='delete_item_btn bg-white p-0' onClick={() => {
                                                const updatedUnits = units.filter((_, i) => i !== index);
                                                setUnits(updatedUnits);
                                            }}><img src="/assets/icons/delete-red-icon.svg" /></button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <button className='add_item_btn border-0 fw-semibold fs-14 primary_text bg-white p-0' onClick={() => {
                                if (units[units.length - 1].trim() !== '') {
                                    setUnits([...units, '']);
                                }
                            }}>+ Add more</button>
                            <div className='modal_btn d-flex justify-content-end gap-2 p-0 mt-4'>
                                <button className='transparent-btn fs-14 py-2' onClick={resetFormFields}>Cancel</button>
                                <button className='primary-btn fs-14 py-2' onClick={handleSubmit}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >


            {/* Edit Food Category Modal */}
            <div className="modal fade" id="editFoodCategoryModal" tabIndex={-1} aria-labelledby="editFoodCategoryModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-2 fw-bold text-black" id="editFoodCategoryLabel">Edit Food Category</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body detail-modal-body p-4">
                            <div className='modal-field mb-2'>
                                <div className="input_wrapper">
                                    <label>Food Category Name</label>
                                    <div className="form_field">
                                        <input
                                            type="text"
                                            className={`form-control ${validationErrors.editFoodCategory ? 'is-invalid' : ''}`}
                                            placeholder="Enter food category"
                                            value={editFoodCategory}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.length === 1 && value === ' ') return;
                                                setEditFoodCategory(value);
                                                if (validationErrors.editFoodCategory) {
                                                    setValidationErrors(prev => ({ ...prev, editFoodCategory: false }));
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='modal_btn d-flex justify-content-end gap-2 p-0 mt-4'>
                                <button className='transparent-btn fs-14 py-2' data-bs-dismiss="modal">Cancel</button>
                                <button className='primary-btn fs-14 py-2' onClick={handleEditFoodCategorySubmit}>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="addFoodCategoryModal" tabIndex={-1} aria-labelledby="addFoodCategoryModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-2 fw-bold text-black" id="addFoodCategoryLabel">Add new food category</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body detail-modal-body p-4">
                            <div className='modal-field mb-2'>
                                <div className="input_wrapper">
                                    <label>Food Category Name</label>
                                    <div className="form_field">
                                        <input
                                            type="text"
                                            className={`form-control ${validationErrors.foodCategory ? 'is-invalid' : ''}`}
                                            placeholder="Enter food category"
                                            value={foodCategory}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.length === 1 && value === ' ') return;
                                                setFoodCategory(value);
                                                if (validationErrors.foodCategory) {
                                                    setValidationErrors(prev => ({ ...prev, foodCategory: false }));
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='modal_btn d-flex justify-content-end gap-2 p-0 mt-4'>
                                <button className='transparent-btn fs-14 py-2' data-bs-dismiss="modal">Cancel</button>
                                <button className='primary-btn fs-14 py-2' onClick={handleSubmit4}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* add productType modal */}
            < div className="modal fade" id="addProductTypeModal" tabIndex={- 1
            } aria-labelledby="addProductTypeModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-2 fw-bold text-black" id="addProductTypeLabel">Add new product type</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body detail-modal-body p-4">
                            <div className='modal-field mb-2'>

                                <div className="input_wrapper">
                                    <label>Product Type</label>
                                    <div className="form_field">
                                        <input type="text" className={`form-control ${validationErrors.productType ? 'is-invalid' : ''}`} placeholder="Enter product type" value={productType} onChange={(e) => {
                                            const value = e.target.value;
                                            if (value.length === 1 && value === ' ') return;
                                            setProductType(value);
                                            if (validationErrors.productType) {
                                                setValidationErrors(prev => ({ ...prev, productType: false }));
                                            }
                                        }} />
                                    </div>
                                </div>

                            </div>

                            <div className='modal_btn d-flex justify-content-end gap-2 p-0 mt-4'>
                                <button className='transparent-btn fs-14 py-2' onClick={resetFormFields}>Cancel</button>
                                <button className='primary-btn fs-14 py-2' onClick={handleSubmit2}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            {/* add units modal */}
            < div className="modal fade" id="addUnitsModal" tabIndex={- 1
            } aria-labelledby="addUnitsModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-2 fw-bold text-black" id="addUnitsLabel">Add new unit</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body detail-modal-body">
                            <div className='modal-field mb-2'>

                                <div className="input_wrapper">
                                    <label>Name</label>
                                    <div className="form_field">
                                        <input type="text" className={`form-control ${validationErrors.singleUnit ? 'is-invalid' : ''}`} placeholder="Enter unit" value={singleUnit} onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^[a-zA-Z\s]*$/.test(value)) {
                                                // Prevent setting a single space
                                                if (value.length === 1 && value === ' ') return;

                                                setSingleUnit(value);

                                                if (validationErrors.singleUnit) {
                                                    setValidationErrors(prev => ({ ...prev, singleUnit: false }));
                                                }
                                            }
                                        }} />
                                    </div>
                                </div>

                            </div>

                            <div className='modal_btn d-flex justify-content-end gap-2 p-0 mt-4'>
                                {/* <button className='transparent-btn fs-14 py-2' onClick={resetFormFields}>Cancel</button> */}
                                <button className='primary-btn fs-14 py-2' onClick={handleSubmit3}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default ContentManagement